<template>
  <div>
    <div class="mt-6 mx-10 flex items-center mb-10">
      <img
        style="height:36px"
        src="../../assets/logo-with-text.png"
      >
      <TheTopProgressBar
        :number-of-dots="3"
        :ratio="ratio"
        class="m-auto"
      />
    </div>

    <div class="max-w-lg mx-auto mb-10">
      <BaseTitle class="mb-8">{{ title }}</BaseTitle>
      <slot />
      <div
        v-if="!noButtons"
        class="flex justify-between items-center"
      >
        <div>
          <BaseButton
            :title="$t('Back')"
            :to="backRoute"
            theme="secondary"
          />
        </div>
        <div class="flex">
          <BaseButton
            :title="$t('Continue later')"
            theme="outlined"
            class= "mr-2"
            @click.native="continueLater"
          />
          <BaseButton
            :title="$t('Next step')"
            :theme="nextButtonTheme"
            @click.native="$emit('next')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseLogo from '../../components/BaseLogo.vue';
import BaseTitle from '../../components/BaseTitle.vue';
import TheTopProgressBar from '../../components/TheTopProgressBar.vue';
import BaseFormPartHeader from '../../components/BaseFormPartHeader.vue';
import BaseButton from '../../components/BaseButton.vue';

export default {
  name: 'Desktop',
  components: {
    BaseLogo,
    TheTopProgressBar,
    BaseFormPartHeader,
    BaseButton,
    BaseTitle,
  },
  props: {
    ratio: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    backRoute: {
      type: String,
      default: null,
    },
    nextButtonTheme: {
      type: String,
      default: 'primary',
    },
    noButtons: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions('kyc', ['update']),
    continueLater() {
      this.update();
      localStorage.lastKycPage = this.$route.name;
      this.$router.push('/opportunities');
    },
  },
};
</script>
